import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import DigitalMarketingDelhi from "../components/blogs/DigitalMarketingDelhi";

const DigitalMarketingAgencyDelhi = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.search) {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <>
      <Helmet>
        <title>Digital Marketing Agency in Delhi | SMS ZOO ZOO</title>
        <meta
          name="description"
          content="Looking for a digital marketing agency in Delhi? SMS ZOO ZOO helps businesses scale with SEO, Google Ads, and data-driven strategies."
        />

        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://www.smszoozoo.com/digital-marketing-agency-delhi"
        />
      </Helmet>

      <Navbar />
      <DigitalMarketingDelhi />
      <Footer />
    </>
  );
};

export default DigitalMarketingAgencyDelhi;
